export enum COOKIE_KEY {
  accessToken = "accessToken",
  ctnToken = "ctnToken",
  connectedWallet = "connectedWallet",
  language = "language",
}
